import React, { Component } from 'react'
// model
import ResourceItem from '../../models/resourceItem'
import ReactPlayer from 'react-player'
interface iProps {
    extraProps: ResourceItem,
    eventTrackingReport?: (resource_id: string, watch_at: number, look_time: number) => void
}
interface iState {
    playStartTime: number // 本次视频开始播放的时间
}
let videoInterval = null // 观看视频定时器
export default class clazzVideo extends Component<iProps, iState> {
    state: iState = {
        playStartTime: null
    }
    vieoProgressCallback = (params) => {
        console.log(params)
    }
     // 视频开始播放
    videoPlay = () => {
        console.log('视频开始播放')
        let that = this
        let {extraProps} = this.props
        this.setState({playStartTime: (+new Date())})
        videoInterval = setInterval(() => {
            that.props.eventTrackingReport(extraProps?.id,this.state.playStartTime, 10)
        }, 10000)
    }
    // 视频开始播放
    videoPause = () => {
        console.log('视频暂停播放')
        videoInterval && clearInterval(videoInterval)
    }
    // 阻止视频右键点击下载
    onContextMenu(e){
        e.preventDefault()
        // alert("右单击")
    }
    componentWillUnmount () {
        videoInterval && clearInterval(videoInterval)
    }
    componentDidMount () {
        if (this.props.extraProps.resourceType && this.props.extraProps.resourceType === 'LINK') {
            window.open(this.props.extraProps.playUrl, '_blank')
        }
    }
    render() {
        let {extraProps} = this.props
        return (
            <div 
                className='clazzVideo player-wrapper' onContextMenu={this.onContextMenu.bind(this)}>
                <ReactPlayer
                    className='react-player'
                    url={extraProps?.playUrl}
                    controls
                    width='96%'
                    height='100%'
                    onProgress={this.vieoProgressCallback}
                    onPlay={this.videoPlay}
                    onPause={this.videoPause}
                    onContextMenu={(e) => e.preventDefault()}
                    config={{
                      file: { attributes: { controlsList: "nodownload noplaybackrate" ,disablePictureInPicture: true} },
                    }}
                />
            </div>
        )
    }
}

